import { render } from "./StoresView.vue?vue&type=template&id=a43780c0"
import script from "./StoresView.vue?vue&type=script&lang=js"
export * from "./StoresView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__